<section>
    <mat-card appearance="outlined" style="width: 1376px;">
        <div style="border-color: black;">
            <h3 style="font-weight: 500;">Assessment Responses</h3>
            <table>                
                <tr>                                                               
                    <td>
                        <label style="padding-right: 10px;font-weight: bold;">Date Raised</label>
                        <mat-form-field appearance="outline">                            
                            <input matInput [readonly] = "disableSelect" style="background-color:#e9ecef" [matDatepicker]="myDatepicker" id="DateRaised" [(ngModel)]="objAssClass.DateRaised" name="DateRaised">
                            <mat-datepicker-toggle  disabled=true [for]="myDatepicker" matSuffix></mat-datepicker-toggle>
                            <mat-datepicker #myDatepicker></mat-datepicker>
                        </mat-form-field>
                    </td> 

                    <td>
                        <label style="margin-left: 65px;padding-right: 10px;font-weight: bold;">Client</label>
                        <mat-form-field appearance="outline">                            
                            <input matInput id="ClientName" style="background-color:#e9ecef" [(ngModel)]="objAssClass.ClientName" name="ClientName"  [readonly] = "disableSelect">                                       
                        </mat-form-field>
                    </td>
                    <td>
                        <label style="margin-left: 65px;padding-right: 10px;font-weight: bold;">Contract</label>
                        <mat-form-field appearance="outline">                            
                            <input matInput id="ContractNumber" style="background-color:#e9ecef" [(ngModel)]="objAssClass.ContractNumber" name="ContractNumber"  [readonly] = "disableSelect">                                       
                        </mat-form-field>
                    </td>
                    <td>
                        <label style="margin-left: 65px;padding-right: 10px;font-weight: bold;">Contract Name</label>
                        <mat-form-field appearance="outline">                            
                            <input matInput id="ContractName" style="background-color:#e9ecef" [(ngModel)]="objAssClass.ContractName" name="ContractName"  [readonly] = "disableSelect">                                       
                        </mat-form-field>
                    </td>                   
                </tr>
            </table>
            <table>
                <tr>
                    <td>
                        <label style="padding-right: 10px;">Title</label>                   
                        <mat-form-field appearance="outline" style="width: 1300px;" >                            
                            <input matInput style="width: 1300px;background-color:#e9ecef" [readonly] = "disableSelect" id="TitleAssess" [(ngModel)]="objAssClass.AssessmentName" name="TitleAssess">
                        </mat-form-field>
                    </td>
                </tr>
            </table>
            <table>
                <tr>
                    <td>
                        <form [formGroup]="productForm" >      
                            <table  formArrayName="quantities">
                              <tr>
                                <label>Question</label>     
                              </tr>
                              <tr *ngFor="let quantity of quantities().controls; let i=index" [formGroupName]="i">
                                  <table>
                                  <tr>
                                    <td style="display: none">
                                        <mat-form-field appearance="outline" style="width: 1335px;">                                                                           
                                          <textarea matInput rows="3" id="QuestionID{{i}}" class="form-control" formControlName="QuestionID"></textarea>
                                      </mat-form-field>
                                    </td>
                                    </tr>                                   
                                    <tr>
                                <td>
                                    <mat-form-field appearance="outline" style="width: 1335px;">                                      
                                      <textarea matInput rows="3" [readonly] = "disableSelect" id="Question{{i}}" class="form-control" formControlName="Question"></textarea>
                                  </mat-form-field>
                                </td>
                            </tr>
                            <tr>
                                <label>Response</label>     
                              </tr>  
                            <tr>
                                <td>
                                    <mat-form-field appearance="outline" style="width: 1335px;">                                                                          
                                      <textarea matInput rows="3" id="Response{{i}}" class="form-control" formControlName="Response"></textarea>
                                  </mat-form-field>
                                </td> 
                            </tr> 
                        </table>                                     
                              </tr>                              
                            </table>                      
                            
                          </form>
                    </td>
                </tr>
            </table>
            <div align="center">               
                <button (click)="onSubmit()" class="buttonnewvul">Save</button>                        
                <button (click)="onCancel()" class="buttonnewvul" style="margin-left: 10px;">Cancel</button>                        
            </div>
        </div>
    </mat-card>
</section>
